import { DiffOutlined, DownloadOutlined, EditOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, message, Tag, Tooltip, Upload } from 'antd';
import { UploadChangeParam } from 'antd/lib/upload';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { TestProjectDataStore, TestProjectWizardStore } from '../../stores';

type Props = {
    store: TestProjectDataStore;
    onGoToBaselines: () => void;
    wizardStore: TestProjectWizardStore;
    onEditInputs: () => void;
    onMapInputs: () => void;
    inputsDisabled?: boolean;
};

const TestProjectBaseline: React.FC<Props> = ({
    store,
    wizardStore,
    onGoToBaselines,
    onEditInputs,
    onMapInputs,
    inputsDisabled
}) => {
    const [isUploading, setIsUploading] = React.useState(false);

    const onFileChange = (info: UploadChangeParam) => {
        const status = info.file.status;
        setIsUploading(status === 'uploading');
        if (status !== 'uploading') {
            console.log(info.file, info.fileList);
        }
        if (status === 'done') {
            message.success(`${info.file.name} file uploaded successfully`);
            store.loadTestProject();
        } else if (status === 'error') {
            message.error(`${info.file.name} file upload failed. Error: ${info.file.response.title}`, 5);
        }
    };

    const openDocumentEditDialog = () => {
        wizardStore.setUpTestProject(store.testProjectId);
        wizardStore.setPackagesEditDialogVisible(true);
    };

    const newDocsTag = () => {
        if (store.testProject?.newPackageIds?.length && !store.isLoadingTestProject) {
            return (
                <Tag color="#52c41a" style={{ marginLeft: 8, marginRight: 0 }}>
                    {store.testProject?.newPackageIds?.length} new
                </Tag>
            );
        }
        return null;
    };

    return (
        <div className="test-project-dashboard-item">
            <div className="item-title">Baseline</div>
            <div className="item-subtitle">
                <div className="item-subtitle-label" style={{ marginLeft: -12 }}>
                    <Button type="link" onClick={openDocumentEditDialog}>
                        {`${store.testProject?.packageIds?.length} documents`}
                        {newDocsTag()}
                    </Button>
                </div>
                <div className="item-subtitle-label">
                    <Button
                        type="link"
                        onClick={onEditInputs}
                        disabled={inputsDisabled}
                    >{`${store.testProject?.topics?.length} inputs`}</Button>
                </div>
                <div className="item-subtitle-extra">
                    <Tooltip title="Change topic type">
                        <Button
                            size="small"
                            type="link"
                            icon={<DiffOutlined />}
                            onClick={onMapInputs}
                            disabled={inputsDisabled}
                        />
                    </Tooltip>
                    <Tooltip title="Edit baselines">
                        <Button size="small" type="link" icon={<EditOutlined />} onClick={onGoToBaselines} />
                    </Tooltip>
                    <Tooltip title="Upload baselines">
                        <Upload
                            disabled={isUploading || !store.canUseProject}
                            name="file"
                            maxCount={1}
                            action={store.baselineUploadUrl}
                            onChange={onFileChange}
                            showUploadList={false}
                            progress={undefined}
                        >
                            <Button size="small" type="link" icon={<UploadOutlined />} loading={isUploading} />
                        </Upload>
                    </Tooltip>
                    <Tooltip title="Download baselines">
                        <Button
                            size="small"
                            type="link"
                            icon={<DownloadOutlined />}
                            disabled={!store.canUseProject}
                            onClick={store.exportTestProjectBaselines}
                        />
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};

export default observer(TestProjectBaseline);
